//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export enum SocialNetwork {
  Bazaarvoice = 'Bazaarvoice',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Pinterest = 'Pinterest',
  Snapchat = 'Snapchat',
  TikTok = 'TikTok',
  Tumblr = 'Tumblr',
  Twitter = 'Twitter',
  Unknown = 'Unknown',
  YouTube = 'YouTube',
}

export const getSocialNetworkName = (network: SocialNetwork) => {
  switch (network) {
    case SocialNetwork.Bazaarvoice:
      return 'Bazaarvoice';
    case SocialNetwork.Facebook:
      return 'Facebook';
    case SocialNetwork.Instagram:
      return 'Instagram';
    case SocialNetwork.Pinterest:
      return 'Pinterest';
    case SocialNetwork.Snapchat:
      return 'Snapchat';
    case SocialNetwork.TikTok:
      return 'TikTok';
    case SocialNetwork.Tumblr:
      return 'Tumblr';
    case SocialNetwork.Twitter:
      return 'X';
    case SocialNetwork.YouTube:
      return 'YouTube';
    case SocialNetwork.Unknown:
      return 'Unknown';
  }
};
